export default class ConditionalDisplay {
  constructor({ triggerId, targetId, expectedValue }) {
    this.triggerId = triggerId;
    this.targetId = targetId;
    this.expectedValue = expectedValue;

    this.trigger = document.getElementById(this.triggerId);
    this.target = document.getElementById(this.targetId);
  }

  mount() {
    if (!this.trigger || !this.target) return;

    this.onChange = this.handleChange.bind(this);
    this.trigger.addEventListener('change', this.onChange);

    this.requiredFields = Array.from(this.target.querySelectorAll('[required]'));
    this.requiredFields.forEach((field) => field.removeAttribute('required'));

    this.handleChange();
  }

  unmount() {
    if (!this.trigger || !this.target) return;
    this.trigger.removeEventListener('change', this.onChange);
  }

  handleChange() {
    let selectedValue;

    if (this.trigger.tagName === 'SELECT') {
      selectedValue = this.trigger.value;
    } else {
      const selectedInput = this.trigger.querySelector('input:checked');
      selectedValue = selectedInput?.value;
    }

    const shouldShow = selectedValue === this.expectedValue;
    this.target.classList.toggle('none', !shouldShow);

    this.requiredFields?.forEach((field) => {
      if (shouldShow) {
        field.setAttribute('required', '');
      } else {
        field.removeAttribute('required');
      }
    });
  }
}
